/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Logo } from "~/components";
import { useToggle } from "~/hooks";
import { ACTIONS, Can } from "~/services/auth";
import {
  CustomerSwitcher,
  Notifications,
  Recalculation,
  SearchBox,
  Timeframe,
  User,
  YbugWrapper,
} from "./components";
import {
  BillingPeriodWrapper,
  CustomerSwitch,
  HeaderGrid,
  NotificationsWrapper,
  RecalculationWrapper,
  SearchWrapper,
  UserWrapper,
} from "./styles";

export function Header() {
  const [isSearchOpened, toggleIsSearchOpened] = useToggle(false);

  return (
    <HeaderGrid>
      <Logo />
      <Can action={ACTIONS.viewSearchBox}>
        <SearchWrapper isOpen={isSearchOpened}>
          <SearchBox
            isOpen={isSearchOpened}
            onToggleOpen={toggleIsSearchOpened}
          />
        </SearchWrapper>
      </Can>
      <BillingPeriodWrapper>
        <Timeframe />
      </BillingPeriodWrapper>
      <RecalculationWrapper>
        <Recalculation />
      </RecalculationWrapper>
      <Can action={ACTIONS.viewNotifications}>
        <NotificationsWrapper>
          <Notifications />
        </NotificationsWrapper>
      </Can>
      <CustomerSwitch>
        <CustomerSwitcher />
      </CustomerSwitch>
      <UserWrapper>
        <YbugWrapper>
          <User />
        </YbugWrapper>
      </UserWrapper>
    </HeaderGrid>
  );
}
